
export default {
  name: 'Header',
  mixins: [],
  components: {
    FulltextSearch: () => import('@/components/fulltext-search/FulltextSearch.vue'),
    UserDropdown: () => import('@/components/user-dropdown/UserDropdown.vue')
  },
  props: {},
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    closeUserDropdown () {
      this.$refs.dropdown.close()
    }
  }
}
